/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Newsletter - Scroll to it after submit
if (window.location.href.indexOf('?customer_posted=true') > -1) {
    setTimeout(() => {
        document.querySelector('.newsletter-form').scrollIntoView()
    }, 750)
}

// Fix for product list items inside offcanvas mobile menu
document.querySelectorAll('#offcanvas-menu-upsell-collection .btn-atc').forEach(($btn) => {
    $btn.addEventListener('click', () => {
        const offcanvas = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-mobile-menu')
        offcanvas.hide()
    })
})

/*
    Navbar menu items open on hover (not click)
*/
document.querySelectorAll('#navbar .navbar-nav .nav-link.dropdown-toggle').forEach(($item) => {
    $item.addEventListener('mouseenter', () => {
        document.querySelectorAll('#navbar .navbar-nav .nav-link.dropdown-toggle').forEach(($item) => {
            $item.classList.remove('show')
            $item.setAttribute('aria-expaned', 'false')
            $item.nextElementSibling.classList.remove('show')
        })

        $item.classList.add('show')
        $item.setAttribute('aria-expaned', 'true')
        $item.nextElementSibling.classList.add('show')
        $item.nextElementSibling.setAttribute('data-bs-popper', 'none')
    })
    $item.addEventListener('mouseleave', () => {
        if (!$item.nextElementSibling.matches(':hover')) {
            $item.classList.remove('show')
            $item.setAttribute('aria-expaned', 'false')
            $item.nextElementSibling.classList.remove('show')
        }
    })

    $item.addEventListener('click', (e) => {
        window.location.href = $item.getAttribute('href')
    })
})
document.querySelector('#main').addEventListener('mouseenter', () => {
    document.querySelectorAll('#navbar .navbar-nav .nav-link.dropdown-toggle').forEach(($item) => {
        $item.classList.remove('show')
        $item.setAttribute('aria-expaned', 'false')
        $item.nextElementSibling.classList.remove('show')
    })
})

// Swap product card image + price when the size/variant select changes
// (collection grid + offcanvas mobile menu).
window.onChangeProductListItemVariant = (event) => {
    const select = event.target
    const card = select.closest('li.product-list-item, [role="list-item"]')
    if (!card) return

    const selectedOption = select.options[select.selectedIndex]
    const variantImageId = selectedOption.dataset.variantImageId
    const variantImageUrl = selectedOption.dataset.variantImageUrl

    // Price swap. Per-variant final price + effective compare-at are
    // pre-computed in Liquid (see snippets/product-list-item.liquid) so the
    // sale-event discount stays in sync without duplicating the math here.
    const priceFinal = card.querySelector('.product-price-final')
    if (priceFinal && selectedOption.dataset.variantPriceFormatted) {
        priceFinal.textContent = selectedOption.dataset.variantPriceFormatted
    }
    const priceCompare = card.querySelector('.product-price-compare')
    if (priceCompare) {
        const compareFormatted = selectedOption.dataset.variantCompareAtPriceFormatted
        const amountEl = priceCompare.querySelector('.product-price-compare-amount')
        if (compareFormatted) {
            if (amountEl) amountEl.textContent = compareFormatted
            priceCompare.classList.remove('d-none')
        } else {
            priceCompare.classList.add('d-none')
        }
    }

    const carousel = card.querySelector('.product-carousel')
    if (carousel) {
        const slides = carousel.querySelectorAll('.carousel-item')
        let targetIndex = 0
        if (variantImageId) {
            slides.forEach((slide, i) => {
                if (slide.dataset.imageId === variantImageId) targetIndex = i
            })
        }
        bootstrap.Carousel.getOrCreateInstance(carousel).to(targetIndex)
        return
    }

    const img = card.querySelector('img.product-img')
    if (!img) return
    if (!img.dataset.defaultSrc) img.dataset.defaultSrc = img.src
    img.src = variantImageUrl || img.dataset.defaultSrc
}

// Handle Plus/Minus in quantity steppers
window.qtyDecrease = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input')
    const inputValue = Number(input.value)

    if (inputValue > 1) {
        input.setAttribute('value', inputValue - 1)
        input.dispatchEvent(new Event('change'))
    }
}
window.qtyIncrease = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input')
    const inputValue = Number(input.value)

    input.setAttribute('value', inputValue + 1)
    input.dispatchEvent(new Event('change'))
}
// Offcanvas wishlist - Open it if URL contains '#wishlist'
if (window.location.hash.includes('#wishlist')) {
    const offcanvasWishlist = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-wishlist')
    offcanvasWishlist.show()
}

// Gorgias chat - widget adjustments on various occasions
document.querySelectorAll('.offcanvas').forEach(offcanvas => {
    offcanvas.addEventListener('show.bs.offcanvas', () => {
        const el = document.querySelector('#gorgias-chat-container')
        if (el) {
            el.style.display = 'none'
        }
    })
})

document.querySelectorAll('.offcanvas').forEach(offcanvas => {
    offcanvas.addEventListener('hide.bs.offcanvas', () => {
        const el = document.querySelector('#gorgias-chat-container')
        if (el) {
            el.style.display = 'block'
        }
    })
})


// RAVN CHANGE - 03/02/2026
const ATTENTIVE_BACK_IN_STOCK_DESKTOP = '1295901'
const ATTENTIVE_BACK_IN_STOCK_MOBILE = '1297481'

const isMobileView = () => window.matchMedia('(max-width: 767px)').matches

const getAttentiveKey = () =>
  isMobileView()
    ? ATTENTIVE_BACK_IN_STOCK_MOBILE
    : ATTENTIVE_BACK_IN_STOCK_DESKTOP

const triggerAttentive = () => {
  if (window.__attentive && window.__attentive.trigger) {
    window.__attentive.trigger(null, null, null, getAttentiveKey())
  }
}

/* ------------------------------
   Attentive - Collection Page
-------------------------------- */
document
  .querySelectorAll('.btn-notify-me-attentive-collection')
  .forEach(btn => {
    btn.addEventListener('click', () => {
      triggerAttentive()
    })
  })

/* ------------------------------
   Attentive - Product Page
-------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const notifyButtons = document.querySelectorAll('.btn-notify-me-attentive')
  if (!notifyButtons.length) return

  // Wait for Attentive to be available
  const checkAttentive = setInterval(() => {
    if (window.__attentive && window.__attentive.trigger) {
      clearInterval(checkAttentive)
      // Auto-trigger on page load (out of stock case)
      triggerAttentive()
    }
  }, 1000)

  // Fallback: stop after 10s
  setTimeout(() => clearInterval(checkAttentive), 10000)

  // Trigger on button click
  notifyButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      triggerAttentive()
    })
  })
})